<template>
  <base-section id="products">
    <v-container>
      <v-row class="mb-8">
        <v-col
          cols="12"
          md="8"
        >
          <h2 class="hh-h2 mb-4">
            Two products we run ourselves.
          </h2>
          <p class="hh-lead mb-0">
            We use the same agents, mobile stack, and social tooling we sell. That is how we know it works.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-for="product in products"
          :key="product.name"
          cols="12"
          md="6"
        >
          <article
            :class="`hh-panel hh-panel--tint-${product.tint} hh-product`"
          >
            <div class="hh-product__body">
              <div class="hh-product__type">
                {{ product.type }}
              </div>

              <h3 class="hh-product__name mb-3">
                {{ product.name }}
              </h3>

              <p class="hh-product__tagline mb-5">
                {{ product.tagline }}
              </p>

              <p class="hh-muted hh-product__blurb mb-6">
                {{ product.blurb }}
              </p>

              <ul class="hh-product__facts mb-8">
                <li
                  v-for="fact in product.facts"
                  :key="fact"
                >
                  {{ fact }}
                </li>
              </ul>

              <div class="d-flex flex-wrap hh-product__actions">
                <base-action-link
                  :href="product.href"
                  accent
                >
                  {{ product.cta }}
                </base-action-link>

                <base-action-link
                  v-if="product.secondary"
                  :to="product.secondary.to"
                >
                  {{ product.secondary.text }}
                </base-action-link>
              </div>
            </div>
          </article>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionProducts',

    data: () => ({
      products: [
        {
          tint: 'ocean',
          type: 'AI video, for Instagram',
          name: 'VividMotion',
          tagline: 'AI Instagram Reels, made by asking.',
          blurb: 'Describe the reel you want inside the AI chat you already use. VividMotion writes the script, picks a design system, times the scenes, adds narration, and hands you a finished vertical video. You decide what gets posted.',
          facts: [
            '27 design systems and 855 composable scenes',
            'Median render time of 1 minute 12 seconds',
            'Remembers your brand across reels',
            'Nothing publishes without you',
          ],
          href: 'https://vividmotion.io',
          cta: 'Visit vividmotion.io',
        },
        {
          tint: 'magenta',
          type: 'Party games, for iPhone',
          name: 'Total Chaos',
          tagline: 'Turn any hangout into an unforgettable time.',
          blurb: 'A free party game for friends, partners, and family. Create a game, share the code, and play Know Me, Lie Detector, 1v1 Trivia, Fill the Blank, and more from one phone each. Some modes work with no internet at all.',
          facts: [
            'Free on the App Store, rated 13+',
            'Built in React Native by our own team',
            'Airplane Mode for offline play',
          ],
          href: 'https://apps.apple.com/us/app/total-chaos/id6760237060',
          cta: 'Get it on the App Store',
          secondary: { text: 'Support', to: '/support/totalchaos' },
        },
      ],
    }),
  }
</script>

<style lang="sass">
  .hh-product
    height: 100%

    &__body
      position: relative
      padding: 36px

      @media (max-width: 599px)
        padding: 24px

    &__type
      font-size: .95rem
      color: var(--hh-muted)
      margin-bottom: 14px

    &__name
      font-family: var(--hh-font-display)
      font-weight: 500
      font-size: clamp(2.2rem, 4vw, 3rem)
      letter-spacing: -0.02em
      line-height: 1

    &__tagline
      font-size: 1.25rem
      font-weight: 500
      color: var(--hh-text)

    &__blurb
      line-height: 1.65

    &__facts
      list-style: none
      padding: 0
      margin: 0
      display: grid
      gap: 10px

      li
        position: relative
        padding-left: 18px
        color: var(--hh-text)

        &::before
          content: ''
          position: absolute
          left: 0
          top: .6em
          width: 8px
          height: 8px
          border-radius: 50%
          background: var(--hh-cyan)

    &__actions
      gap: 28px
</style>
